export const routes = {
  homepage: '/',
  privacyPolicy: '/privacy-policy',
  login: '/login',
  profile: '/profile',
  dynamicPage: '/:locale/:slug',
  admin: '/admin/locations',
  users: {
    list: '/admin/users',
    create: '/admin/users/new',
    edit: '/admin/users/:id',
  },
  translations: '/admin/translations',
  comingSoon: '/coming-soon',
  languages: '/admin/languages',
  employees: {
    list: '/admin/employees',
    create: '/admin/employees/new',
    edit: '/admin/employees/:id',
  },
  clients: {
    list: '/admin/clients',
    create: '/admin/clients/new',
    edit: '/admin/clients/:id',
  },
  rivals: {
    list: '/admin/rivals',
    create: '/admin/rivals/new',
    edit: '/admin/rivals/:id',
  },
  tasks: {
    list: '/admin/tasks',
    create: '/admin/tasks/new',
    edit: '/admin/tasks/:id',
  },
  locations: {
    list: '/admin/locations',
  },
};
